<template>
  <div class="body">
    <main-page v-on:toRank="scrollToRank"></main-page>
    <div :ref="'rank'">
      <rank class="rank"></rank>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
 import MainPage from '@/components/suzhou/MainPage.vue'
 import Rank from '@/components/suzhou/Rank.vue'

export default {
  name: '',
  components: {
    MainPage,
    Rank
  },
   methods: {
     scrollToRank() {
       console.log(this.$refs['rank'])
       let top = this.$refs['rank'].offsetTop;
       window.scrollTo(0, top-40)
     }
   },
   created () {
     this.$store.commit("SET_FOOTER", false)
     this.$store.commit("SET_HEADER", false)
   }
}
</script>
<style scoped>
 .body{
   background-image: url(/oss/images/suzhou/suzhou_bg.jpg);
   background-size: 100vw;
   /* background-repeat: no-repeat; */
   min-height: 100vh;
 }
</style>
